export var fields = {
    methods: {
        formatInputField(inputField) {
            let sourceName = inputField;
            let destName = inputField;

            if (inputField.includes(":")) {
                const sourceDest = inputField.split(":");
                sourceName = sourceDest[0];
                destName = sourceDest[1];
            }
            return { sourceName, destName };
        },
        textField(dictionary) {
            const result =
                (dictionary.dataType == "string" ||
                    //dictionary.dataType == "real" ||
                    dictionary.dataType == "integer") &&
                !this.checkField(dictionary) &&
                !this.comboField(dictionary) &&
                !this.dateField(dictionary) &&
                !this.dateTimeField(dictionary) &&
                !this.timeField(dictionary) &&
                !this.passwordField(dictionary) &&
                !this.fileInputField(dictionary) &&
                !this.memoField(dictionary) &&
                !this.snippetField(dictionary) &&
                !this.numberField(dictionary) &&
                !this.embedField(dictionary) &&
                !this.signatureField(dictionary);
            return result;
        },

        dateField(dictionary) {
            return dictionary.dataType == "date";
        },

        dateTimeField(dictionary) {
            return dictionary.dataType == "dateTime";
        },

        timeField(dictionary) {
            return dictionary.dataType == "time";
        },

        signatureField(dictionary) {
            return dictionary.dataType == "signature";
        },

        embedField(dictionary) {
            return dictionary.dataType == "embed";
        },

        comboField(dictionary) {
            return this.notBlank(dictionary.catalogType);
        },
        isCatalog(dictionary) {
            return this.comboField(dictionary);
        },
        comboTagField(dictionary) {
            return this.comboField(dictionary) && dictionary.tags;
        },
        comboTagListField(dictionary) {
            return this.comboTagField(dictionary) && dictionary.list;
        },
        comboSimpleField(dictionary) {
            return this.comboField(dictionary) && !dictionary.tags;
        },
        progressField(dictionary) {
            return (
                this.textField(dictionary) &&
                this.fieldTextType(dictionary.dataType) == "number" &&
                dictionary.progress
            );
        },
        checkField(dictionary) {
            return dictionary.dataType === "check";
        },
        passwordField(dictionary) {
            return dictionary.dataType === "password";
        },

        fileField(dictionary) {
            return dictionary.dataType === "file";
        },

        pictureField(dictionary) {
            return dictionary.dataType === "picture";
        },

        pdfField(dictionary) {
            return dictionary.dataType === "pdf";
        },

        memoField(dictionary) {
            return dictionary.dataType === "memo";
        },
        snippetField(dictionary) {
            return dictionary.dataType === "snippet";
        },
        numberField(dictionary) {
            return this.fieldReal(dictionary.dataType);
        },

        interactiveField(access) {
            return (
                this.notBlank(access) &&
                (access == "required" || access == "optional")
            );
        },

        visibleField(access) {
            return (
                this.interactiveField(access) ||
                (this.notBlank(access) && access == "readonly")
            );
        },

        requiredField(access) {
            return access == "required";
        },
        readonlyField(access) {
            return access == "readonly";
        },
        hiddenField(access) {
            return access == "hidden";
        },
        optionalField(access) {
            return access == "optional";
        },

        getFieldId(getId) {
            return "field" + getId;
        },
        getFieldAccess(access, permission, method) {
            let result = access;
            if (method == "delete") {
                result = this.hiddenField(access) ? access : "readonly";
            } else {
                switch (permission) {
                    case "edit": {
                        result = access;
                        break;
                    }
                    case "readonly": {
                        result = "readonly";
                        break;
                    }
                }
            }
            return result;
        },
        getFieldValueByName(name, list, data) {
            const found = list.find((item) => item.formField.fieldName == name);
            const foundIndex = list.findIndex(
                (item) => item.formField.fieldName == name
            );
            if (found && foundIndex >= 0) {
                const id = found.oriIndex
                    ? this.getFieldId(found.oriIndex)
                    : this.getFieldId(foundIndex);
                return data[id].value;
            } else {
                return null;
            }
        },
        getValueType(dictionary) {
            const result =
                dictionary.dataType == "check"
                    ? "boolean"
                    : dictionary.catalogType;
            return result;
        },
        fieldTextType(dataType) {
            var result = "text";
            switch (dataType) {
                case "password": {
                    result = "password";
                    break;
                }
                case "integer": {
                    result = "number";
                    break;
                }
                default: {
                    result = "text";
                    break;
                }
            }
            return result;
        },
        fieldInteger(dataType) {
            return dataType == "integer";
        },
        fieldReal(dataType) {
            return dataType == "real";
        },
        fieldNumeric(dataType) {
            return this.fieldInteger(dataType) || this.fieldReal(dataType);
        },
        fieldAlign(input) {
            const { dictionary, screen } = input;
            const smallQuery = this.smallQuery(screen);
            return smallQuery
                ? "text-left"
                : this.fieldNumeric(dictionary.dataType)
                ? "text-right"
                : this.checkField(dictionary) ||
                  this.pictureField(dictionary) ||
                  this.pdfField(dictionary)
                ? "text-center"
                : "text-left";
        },
        fieldFilterChange(dictionary) {
            return (
                this.comboSimpleField(dictionary) ||
                this.dateField(dictionary) ||
                this.checkField(dictionary)
            );
        },

        cellId(name, idx) {
            return "queryField_" + name + "_" + idx;
        },

        specialForcedField(field) {
            return field.special == "forced";
        },

        fieldAlias(field) {
            return field.alias ? field.alias : field.fieldName;
        },

        fieldPreview(dictionary, fieldPreview) {
            const dictionaryLevel =
                this.pictureField(dictionary) || this.pdfField(dictionary);
            return dictionaryLevel && fieldPreview;
        },

        fileInputField(dictionary) {
            return (
                this.fileField(dictionary) ||
                this.pictureField(dictionary) ||
                this.pdfField(dictionary) ||
                this.signatureField(dictionary)
            );
        },

        dynamicFileField(bucket, dictionary) {
            return (
                bucket &&
                bucket.access == "PRIVATE" &&
                this.fileInputField(dictionary)
            );
        },

        dynamicFileFieldValue(bucket, dictionary, value) {
            return (
                this.dynamicFileField(bucket, dictionary) &&
                value &&
                !this.validateUrl(value)
            );
        },
        smartFieldValue(object, fieldName) {
            try {
                return eval("object." + fieldName, object);
            } catch (e) {
                return null;
            }
        },
        smartSetValue(object, fieldName, value) {
            try {
                return eval("object." + fieldName + "=" + value, object);
            } catch (e) {
                return null;
            }
        },
    },
};
